export var FLATTENED = '__FLATTENED__';
export var CHANNEL = '__ATLASKIT_THEME__';
export var DEFAULT_THEME_MODE = 'light';
export var THEME_MODES = ['light', 'dark'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/modal-dialog/node_modules/@atlaskit/theme/dist/esm/constants.js
// module id = 241
// module chunks = 0